export const environment = {
    ebizRootURL: 'https://epaproject1apps.epa.ohio.gov',
    clientID : '0332f5c5-68c9-414d-82da-aaae0be3f9c4',
    redirectURI: 'https://hsts.project1.epa.ohio.gov',  
};
